import { render, staticRenderFns } from "./active.vue?vue&type=template&id=0ea48180&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"
import style0 from "./active.vue?vue&type=style&index=0&id=0ea48180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea48180",
  null
  
)

export default component.exports